// extracted by mini-css-extract-plugin
export default {"terminal":"TerminalPane_terminal__HMoW9","terminalContainer":"TerminalPane_terminalContainer__dNzFo"};